@if (showCancelButton) {
<cs-button medium secondary [label]="LL.common.buttons.cancel()" (click)="onCancelClick($event)"></cs-button>
}
<ng-content></ng-content>